import {Analytics, GoogleAnalytics, FacebookPixel, GoogleAnalyticsEventObserver} from '@plaudit/analytics';
const analytics = Analytics.getInstance();
const googleAnalytics = analytics.getTracker(GoogleAnalytics.platformName) as GoogleAnalytics;
const facebookPixel = analytics.getTracker(FacebookPixel.platformName) as FacebookPixel;

if (googleAnalytics !== null) {
	// Goal: Email Link - Click
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 250});
			},
			{
				eventCategory:	(value: string) => value === "Email Link",
				eventAction:	(value: string) => value === "Click"
			}
		)
	);

	// Goal: Telephone Link - Click
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 250});
			},
			{
				eventCategory:	(value: string) => value === "Telephone Link",
				eventAction:	(value: string) => value === "Click"
			}
		)
	);

	// Goal: Successful form submission
	googleAnalytics.addHitObserver(
		new GoogleAnalyticsEventObserver(
			() => {
				if (facebookPixel !== null) facebookPixel.trackEventLead({value: 500});
			},
			{
				eventCategory:	(value: string) => value === "Form Success",
				eventAction:	(value: string) => true
			}
		)
	);
}